import React from 'react';
import classess from './BuildControls.css';
import BuildControl from './BuildControl/BuildControl'
const buildControls = (props) => {
    const transformIngredients = Object.keys(props.ingredints).map((ingr, i) => <BuildControl
        onMore={props.onMore}
        onLess={props.onLess}
        disabled={props.ingredints[ingr].amount === 0}
        key={ingr + i}
        label={ingr} />)
    return (
        <div className={classess.BuildControls}>
            <p>{props.totalPrice} AED</p>
            {transformIngredients}

            <button className={classess.OrderButton} disabled={props.totalPrice === 0} onClick={props.onOrder}>ORDER NOW</button>
        </div>
    );
}

export default buildControls;